import React from "react"
import { Flex, Box } from "components/Layout.component"
import { Text } from "components/Typography.component"
import styled from "styled-components"

import { connectorLocalStorageKey, walletLocalStorageKey } from "./config"
import { Config, ConnectorNames, Login } from "./types"

interface Props {
  walletConfig: Config
  login: Login
  closeModal: () => void
}

const WalletButton = styled(Flex)`
  cursor: pointer;
  width: 100%;
  background: #3d1743;
  border-radius: 8px;
  padding: 6px 8px;
  align-items: center;
`

export const WalletCard: React.FC<Props> = ({ login, walletConfig, closeModal }) => {
  const { title, icon: Icon } = walletConfig

  return (
    <WalletButton
      onClick={() => {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

        // Since iOS does not support Trust Wallet we fall back to WalletConnect
        if (walletConfig.title === "Trust Wallet" && isIOS) {
          login(ConnectorNames.WalletConnect)
        } else {
          login(walletConfig.connectorId)
        }

        localStorage.setItem(walletLocalStorageKey, walletConfig.title)
        localStorage.setItem(connectorLocalStorageKey, walletConfig.connectorId)
        closeModal()
      }}
      id={`wallet-connect-${title.toLocaleLowerCase()}`}
    >
      <Icon width="40px" mb="8px" />
      <Box ml={2}>
        <Text fontSize="14px">{title}</Text>
      </Box>
    </WalletButton>
  )
}
